import React from "react";
import MaestroLoader from "@components/MaestroLoader";
import { Box, Button, CardCover, Grid, Typography } from "@mui/joy";
import TableWidget from "./layouts/TableWidget";
import { primaryProperty, useGetAllBusinesses } from "@api/businessService";
import ListWidget from "./layouts/ListWidget";
import { useGetProperty } from "@api/propertyService";
import ObjectPreview from "@components/objects/ObjectPreview";
import { useGetWorkPlan } from "@api/workplanService";
import { formatDate, isValidDate } from "@utils/dates";
import { dueDateClassForTask } from "@utils/dueDateClassForTask";
import { Task } from "@components/Task";
import { useGetAllTasks } from "@api/taskService";
import { useGetAllContacts } from "@api/contactService";
import ErrorLoadingWidget from "./ErrorLoadingWidget";
import { useAuth } from '@providers/AuthProvider'

//<th>Task</th>
{/* <th style={{width: '15%'}}>Due</th> */}

const columns = [
    {
        id: 'task',
        numeric: false,
        disablePadding: true,
        sortable: true,
        label: 'Task',
        // cellRendersTd: true,
        rowClasses: (row, {parentData, LinkComponent}) => {
            // const isValidDueDate = isValidDate(row.due_date);
            // const dueDate = isValidDate(row.due_date) ? formatDate(row.due_date) : null;
            const isCompleted = row.completed_at && isValidDate(row.completed_at);
            return isCompleted ? 'task-complete' : '';
        },
        cell: (row, {LinkComponent}) => {
            return (<Task task={row} displayWorkPlan />)
        }
    },
    {
        id: 'due',
        numeric: false,
        disablePadding: false,
        sortable: false,
        label: 'Due',
        width: '20%',
        classes: (row, {parentData, LinkComponent}) => {
            return dueDateClassForTask(row);
        },
        cell: (row, {parentData, LinkComponent}) => {
            const isValidDueDate = isValidDate(row.due_date);
            const dueDate = isValidDate(row.due_date) ? formatDate(row.due_date) : null;
            const isCompleted = row.completed_at && isValidDate(row.completed_at);

            return (<>
                {isValidDueDate && (<time className={isCompleted ? 'task-complete' : ''}>{dueDate}</time>)}
                {!isValidDueDate && (<>N/A</>)}
            </>)
        }
    },
];

function TaskListPeopleTitle({ids}) {
    const { user } = useAuth();

    if (user?.roles?.some(r => r.name === 'Volunteer')) {
        return <>Tasks assigned to you</>;
    }

    return <TaskListPeopleTitleInner ids={ids} />;
}

function TaskListPeopleTitleInner({ids}) {
    const {
        isLoading,
        isError,
        data,
    } = useGetAllContacts({id: ids.join(','), per_page: -1});

    if (isLoading || isError || !data?.data || !ids.length) {
        return <>N/A</>;
    }

    if (data.data.length > 4) {
        return <>Multiple People's Tasks</>;
    }

    return (
        <>
            Tasks assigned to{' '}
            {data.data.map((contact, contactIndex) => (
                <React.Fragment key={contactIndex}>
                    <ObjectPreview to={`/contacts/${contact.id}`} object={contact}>
                        {contact.name}
                    </ObjectPreview>
                    {contactIndex < data.data.length - 1 && `, `}
                </React.Fragment>
            ))}
        </>
    );
}

export default function WorkPlanTaskListWidget(props) {
    let propOpts = {
        filter_mode: 'and',
        completed_at: "null",
        orderby: 'overdue',
        include: 'workplan,contacts',
        // paginate: '-1'
    };

    if(props?.options?.viewType === 'contact') {
        propOpts['contacts.id'] = props?.options?.ids?.join(',') ?? '';

        if((props?.options?.ids ?? []).length === 0) {
            return (
                <ErrorLoadingWidget
                    {...props}
                    error={true}
                    title={(data, parentData) => (
                        props.options.viewType === 'all'
                            ? <>All Incomplete Tasks</>
                            : <TaskListPeopleTitle ids={props?.options?.ids ?? []} />
                    )}
                    message={'Please edit this widget and choose contact(s) to display.'}
                />
            )
        }

    }

    return (
        <ListWidget
            {...props}
            title={(data, parentData) => (
                props.options.viewType === 'all'
                    ? <>All Incomplete Tasks</>
                    : <TaskListPeopleTitle ids={props?.options?.ids ?? []} />
            )}
            query={useGetAllTasks}
            requestParams={propOpts}
            columns={columns}
        />
    );
}
